import { ReactNode } from "react";
import styles from "@/components/pages/beats/styles/beat-setting.module.scss";
import IntegerStyledInput from "@/components/common/input/integer-styled-input";

type BeatSettingParameter = {
  title: string;
  value: number;
  onValueChanged: (value: number) => void;
  isDisabled?: boolean;
};

type BeatSettingsProps = {
  header: ReactNode;
  parameters: BeatSettingParameter[];
  isValid: boolean;
  validationErrors?: string[];
};

const BeatSetting = ({
  header,
  parameters,
  isValid,
  validationErrors,
}: BeatSettingsProps) => {
  return (
    <div
      className={isValid ? styles.setting_block : styles.setting_block_error}
    >
      {header}
      {parameters.length !== 0 && (
        <>
          <div className={styles.setting_parameters_container}>
            {parameters.map((parameter, index) => (
              <div key={index} className={styles.setting_parameter_wrapper}>
                <IntegerStyledInput
                  title={parameter.title}
                  value={parameter.value}
                  onValueChanged={parameter.onValueChanged}
                  isDisabled={parameter.isDisabled}
                />
              </div>
            ))}
          </div>
          {!isValid && validationErrors && validationErrors.length > 0 && (
            <div className={styles.errors_container}>
              {validationErrors.map((error, i) => (
                <div key={i} className={styles.validation_error_text}>
                  {error}
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default BeatSetting;
